"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formik = require("formik");
var _fieldNames = require("./fieldNames");
var _grid = _interopRequireDefault(require("./grid"));
var _busca = _interopRequireDefault(require("./busca"));
var _core = require("@stt-componentes/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    label: {
      marginBottom: theme.spacing(1)
    }
  };
});
var Cid10 = function Cid10(_ref) {
  var strings = _ref.strings,
    _ref$obrigatorio = _ref.obrigatorio,
    obrigatorio = _ref$obrigatorio === void 0 ? false : _ref$obrigatorio,
    _ref$verificarErrosOr = _ref.verificarErrosOrdemPrecedencia,
    verificarErrosOrdemPrecedencia = _ref$verificarErrosOr === void 0 ? null : _ref$verificarErrosOr,
    headers = _ref.headers,
    formExterno = _ref.formExterno,
    _ref$multiplos = _ref.multiplos,
    multiplos = _ref$multiplos === void 0 ? false : _ref$multiplos,
    _ref$capCiap = _ref.capCiap,
    capCiap = _ref$capCiap === void 0 ? null : _ref$capCiap,
    _ref$nomeCampo = _ref.nomeCampo,
    nomeCampo = _ref$nomeCampo === void 0 ? 'cid10' : _ref$nomeCampo,
    titulo = _ref.titulo,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var _formExterno$cid = formExterno.cid10,
    cid10 = _formExterno$cid === void 0 ? [] : _formExterno$cid,
    errors = formExterno.errors,
    isSubmitting = formExterno.isSubmitting,
    submitCount = formExterno.submitCount,
    setFieldValue = formExterno.setFieldValue;
  var classes = useStyles();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var handleClick = function handleClick() {
    setOpen(!open);
  };
  var secaoCid = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (isSubmitting) {
      return;
    }
    if (obrigatorio && errors !== null && errors !== void 0 && errors[_fieldNames.CID_10] && verificarErrosOrdemPrecedencia && !verificarErrosOrdemPrecedencia(errors, _fieldNames.CID_10)) {
      setTimeout(function () {
        secaoCid.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'start'
        });
      }, 50);
    }
  }, [isSubmitting, obrigatorio]);
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    onSubmit: function onSubmit(values) {
      setFieldValue(nomeCampo, values.cid10);
    },
    enableReinitialize: true,
    initialValues: {
      cid10: cid10
    }
  }, function (_ref2) {
    var values = _ref2.values;
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_formik.FieldArray, {
      name: _fieldNames.CID_10,
      render: function render(_ref3) {
        var _values$cid;
        var push = _ref3.push,
          remove = _ref3.remove;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
          container: true,
          spacing: 3
        }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/_react["default"].createElement(_core.SttFormLabel, {
          component: "legend",
          required: obrigatorio,
          className: classes.label,
          error: !!errors[_fieldNames.CID_10] && submitCount > 0
        }, titulo ? titulo : strings.cid10), (((_values$cid = values.cid10) === null || _values$cid === void 0 ? void 0 : _values$cid.length) === 0 || multiplos) && !disabled && /*#__PURE__*/_react["default"].createElement(_core.SttButton, {
          variant: "contained",
          color: "secondary",
          nomarginleft: "true",
          onClick: handleClick
        }, strings.buscar), obrigatorio && (errors === null || errors === void 0 ? void 0 : errors[_fieldNames.CID_10]) && submitCount > 0 && /*#__PURE__*/_react["default"].createElement(_core.SttFormHelperText, {
          error: true
        }, strings.campoObrigatorio)), /*#__PURE__*/_react["default"].createElement(_busca["default"], {
          strings: strings,
          open: open,
          setOpen: setOpen,
          handleAdd: push,
          headers: headers,
          multiplos: multiplos,
          capCiap: capCiap
        })), /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/_react["default"].createElement("div", {
          ref: secaoCid
        }, /*#__PURE__*/_react["default"].createElement(_grid["default"], {
          strings: strings,
          cid10: values.cid10,
          handleDelete: remove,
          disabled: disabled
        })))));
      }
    }));
  });
};
Cid10.propTypes = {
  strings: _propTypes["default"].object.isRequired,
  titulo: _propTypes["default"].string,
  obrigatorio: _propTypes["default"].bool,
  multiplos: _propTypes["default"].bool,
  headers: _propTypes["default"].object.isRequired,
  formExterno: _propTypes["default"].object.isRequired,
  verificarErrosOrdemPrecedencia: _propTypes["default"].func
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Cid10);